__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "accountConsole";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "21.2.11", () => (__webpack_require__.e(613).then(() => (() => (__webpack_require__(6613))))));
			register("@angular/common", "21.2.11", () => (__webpack_require__.e(352).then(() => (() => (__webpack_require__(1352))))));
			register("@angular/core/primitives/di", "21.2.11", () => (__webpack_require__.e(513).then(() => (() => (__webpack_require__(8513))))));
			register("@angular/core/primitives/signals", "21.2.11", () => (__webpack_require__.e(699).then(() => (() => (__webpack_require__(6699))))));
			register("@angular/core/rxjs-interop", "21.2.11", () => (__webpack_require__.e(693).then(() => (() => (__webpack_require__(9074))))));
			register("@angular/core", "21.2.11", () => (__webpack_require__.e(460).then(() => (() => (__webpack_require__(9460))))));
			register("@angular/router", "21.2.11", () => (__webpack_require__.e(445).then(() => (() => (__webpack_require__(8826))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};